import { MerchantType } from './Merchant.types';

export interface IFoxtrotData {
	eventData: {
		merchantType?: MerchantType;
		merchantId?: string;
		merchantUserId?: string;
		userId?: string;
		name: string;
		[key: string]: unknown;
	};
	eventType: string;
}

export interface IFoxtrotEvent extends IFoxtrotData {
	app: string;
	id: string;
	groupingKey: string;
	farmId: string;
	eventSchemaVersion: string;
	time: number;
	eventTTLBucket: string;
	eventCriticalityBucket: string;
}

export enum UserTokenType {
	GANDALF_TOKEN = 'GANDALF_TOKEN',
	OLYMPUS_TOKEN = 'OLYMPUS_TOKEN',
}
